export default {
    active_requirement_orders: "Активні наряд-замовлення",
    add_laboratory_service: "Додати лабораторну послугу",
    after_finished_fixed: "За фактом проведення",
    can_have_dental_work: "Може містити зуботехнічні роботи",
    cannot_change_services_that_already_have_laboratory_services_attached: "Не можна видалити послуги, до яких вже прив'язані лабораторні роботи із наряд-замовлення",
    carcass: "Каркас",
    deleted_from_treatment: "Видалено із лікування",
    delivery_date: "Дата видачі",
    dental_work: "Зуботехнічні роботи",
    do_you_confirm_cancel_laboratory_order: "Ви дійсно хочете скасувати наряд-замовлення?",
    do_you_confirm_laboratory_order_finish: "Ви підтверджуєте, що роботу пацієнту здано? Після підтвердження, буде нарахована зарплата лікарю, а зміни за даним нарядом-замовленням будуть неможливі.",
    do_you_confirm_laboratory_order_finish2: "Ви підтверджуєте, що роботу пацієнту здано? ",
    executor: "Виконавець",
    faintly: "Слабко",
    field_is_required: "Поле обов'язкове",
    fitting_date: "Дата примірки",
    full: "Повний",
    immediately: "Відразу",
    in_clinic: "В клініці",
    in_lab: "В лабораторії",
    initiated: "Ініційований",
    intermediate_part_design: "Дизайн проміжної частини",
    laboratories: "Лабораторії",
    laboratory: "Лабораторія",
    laboratory_service: "Лабораторна послуга",
    LaboratoryOrder: "Наряд-замовлення",
    logics_on_laboratory_services_deduction: "Логіка віднімання лабораторних робіт з наряд-замовлення",
    moderately: "Помірно",
    must_have_dental_work: "Обов'язково містить зуботехнічні роботи",
    no_dental_work_needed_for_selected_services: "Для вибраних послуг зуботехнічні роботи не потрібні",
    no_services: "Немає послуг",
    order_number: "Номер наряду",
    paint_restorations: "Забарвити реставрації",
    panorama: "Панорама",
    pay_all: "Оплатити все",
    requirement_order: "Вимога - замовлення",
    select_from_price: "Вибрати з прайсу",
    send_to_laboratory_via_messenger: "Надіслати лабораторії через месенджер",
    shoulder: "Плечо",
    simplified: "Спрощений",
    total_orders_for_the_amount: "Всього нарядів на суму",
    when_changeing_laboratory_all_selected_services_will_be_removed_continue: "При зміні лабораторії всі вибрані послуги будуть видалені зі списку. Продовжити?",
    without_attachment_to_tooth: "Без прив'язки до зуба"
}
